import { Component, Input } from '@angular/core';
import { NavigationItemInterface } from './navigation-item.interface';

@Component({
  selector: 'un-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
})
export class HeaderComponent {
  @Input() public logo?: string;
  @Input() public logoUrl?: string;
  @Input() public brand?: string;
  @Input() public navigationItems: NavigationItemInterface[] = [];
}
